var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor__wrapper"},[_c('vue-editor',_vm._b({class:{'editor--disabled': _vm.disabled},attrs:{"editor-toolbar":_vm.toolbar,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}},'vue-editor',_vm.$attrs,false)),(_vm.disabled)?_c('div',{staticClass:"editor__disabled-mask"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }